import React from "react";
import CTASecondary from "../CTASecondary";
import costa from "../../img/about/costa.png";
import "./AboutLand.css";
function AboutLand() {
  return (
    <div className="AboutLand">
       <div className="AboutLand__img">
        <img src={costa} alt="Luxury villa with sea view in Costa Blanca, Spain" />
      </div>
      <div className="AboutLand__left">
        <h1>costa blanca</h1>
        <p>
          The Costa Blanca is a region on the southeastern coast of Spain, known
          for its beautiful beaches, charming coastal towns, and sunny
          Mediterranean climate. 
          <br />
          <br />The exact starting and finishing points of the
          Costa Blanca coast can vary depending on the interpretation, but
          generally, it stretches approximately from the town of Denia in the
          north to Pilar de la Horadada or even Torrevieja in the south,
          covering about 200 kilometers (125 miles) of coastline along the
          province of Alicante in the Valencian Community.
        </p>
        <a href="/properties"><CTASecondary label="View properties" /></a>
      </div>
      <div className="AboutLand__right">
        <img src={costa} alt="Luxury villa with sea view in Costa Blanca, Spain" />
      </div>
    </div>
  );
}

export default AboutLand;
